import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHotelFilter, EPriceDisplayMode, EBookingMode } from 'types';

/**
 * Redux slice for managing hotel/space filter, price display mode, and booking mode.
 * Filter state is persisted to localStorage for user convenience.
 */
export const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    value: null as IHotelFilter | null,
    priceDisplayMode: EPriceDisplayMode.GROSS,
    bookingMode: EBookingMode.EPILO,
    combinedBookingView: false,
  },
  reducers: {
    setFilter: (state, { payload }: PayloadAction<IHotelFilter>) => {
      state.value = payload;
    },
    resetFilter: state => {
      state.value = null;
    },
    setPriceDisplayMode: (state, action: PayloadAction<EPriceDisplayMode>) => {
      state.priceDisplayMode = action.payload;
    },
    setBookingMode: (state, action: PayloadAction<EBookingMode>) => {
      state.bookingMode = action.payload;
    },
    setCombinedBookingView: (state, action: PayloadAction<boolean>) => {
      state.combinedBookingView = action.payload;
    },
  },
});

export const { setFilter, resetFilter, setPriceDisplayMode, setBookingMode, setCombinedBookingView } = filterSlice.actions;
export const filterReducer = filterSlice.reducer;

export default filterSlice;
